import React, { useState } from 'react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { useAdminToast } from '../../../../hooks/useAdminToast';
import { ModalWrapper, FormInput } from './ModalComponents';

const CreateWithdrawalModal = ({ clientId, balance, onClose, onSuccess }) => {
  const { toast } = useAdminToast();
  const [form, setForm] = useState({ amount: '', address: '', currency: 'USDT', notes: '', auto_complete: false });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.amount || parseFloat(form.amount) <= 0 || !form.address) return;
    setLoading(true);
    try {
      await adminAPI.createWithdrawal({ user_id: clientId, amount: parseFloat(form.amount), ...form });
      onSuccess();
    } catch (err) {
      toast.apiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWrapper title="Создать вывод" onClose={onClose}>
      <div style={{ marginBottom: '16px', padding: '10px', backgroundColor: COLORS.background, borderRadius: '8px' }}>
        <span style={{ color: COLORS.textSecondary, fontSize: '12px' }}>Доступно: </span>
        <span style={{ color: COLORS.text, fontWeight: '600' }}>${balance.toFixed(2)}</span>
      </div>
      <FormInput label="Сумма ($)" value={form.amount} onChange={(v) => setForm({ ...form, amount: v })} type="number" />
      <FormInput label="Адрес вывода" value={form.address} onChange={(v) => setForm({ ...form, address: v })} />
      <FormInput label="Комментарий" value={form.notes} onChange={(v) => setForm({ ...form, notes: v })} />
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', color: COLORS.text, fontSize: '14px', marginTop: '12px' }}>
        <input 
          type="checkbox" 
          checked={form.auto_complete} 
          onChange={(e) => setForm({ ...form, auto_complete: e.target.checked })} 
          style={{ width: '18px', height: '18px', accentColor: COLORS.danger }} 
        />
        Автоматически выполнить (списать с баланса)
      </label>
      <button 
        onClick={handleSubmit} 
        disabled={loading || !form.amount || !form.address} 
        style={{ 
          width: '100%', 
          marginTop: '20px', 
          padding: '14px', 
          backgroundColor: loading || !form.amount ? COLORS.border : COLORS.danger, 
          border: 'none', 
          borderRadius: '8px', 
          color: '#fff', 
          fontSize: '15px', 
          fontWeight: '600', 
          cursor: loading || !form.amount ? 'not-allowed' : 'pointer' 
        }}
      >
        {loading ? 'Создание...' : 'Создать вывод'}
      </button>
    </ModalWrapper>
  );
};

export default CreateWithdrawalModal;
